<template>
  <div>
    <page-header has-return :page="page" @onReturn="$router.back" />
    <div class="row">
      <div class="col-12">
        <filter-manager
          v-model="filter.model"
          ref="filterRef"
          :filters="filters"
          :display-advanced="false"
          search-text="Procesar"
          search-icon="fa fa-sync"
          search-container-class="btn-process-custom"
          items-container-class="flex-wrap"
          :is-advanced="false"
          @search="process"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@/modules/report/document';

export default {
  name: 'TherapyRoomsHipaaMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data() {
    return {
      filter: {
        collections: {
          academicYears: [],
          centers: [],
          municipalities: [],
          schools: [],
          statuses: [
            { id: true, name: 'Cumple' },
            { id: false, name: 'No cumple' },
          ],
        },
        model: {
          academicYear: null,
          center: null,
          municipality: null,
          school: null,
          status: null,
        },
      },
    };
  },
  computed: {
    page() {
      return {
        title: 'Salones de terapia HIPAA',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m',
        routes: ['Inicio', 'Informes Generales', 'Salones de terapia HIPAA'],
      };
    },
    filters() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Fiscal',
          placeholder: 'Seleccionar',
          validations: 'required',
          error: 'El año académico es requerido.',
          class: 'col-md-3',
          clearable: false,
          options: this.filter.collections.academicYears,
          value: this.filter.model.academicYear,
          disabled:
            this.filter.model.academicYear &&
            this.filter.collections.academicYears.length === 1,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'CSEE',
          placeholder: 'Seleccionar',
          validations: 'required',
          error: 'El CSEE es requerido.',
          class: 'col-md-3',
          options: this.filter.collections.centers,
          value: this.filter.model.center,
          disabled: !this.filter.model.academicYear,
          onChanged: this.onChangeCenter,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Municipio',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.filter.collections.municipalities,
          value: this.filter.model.municipality,
          disabled: !this.filter.model.center,
          onChanged: this.onChangeMunicipality,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Escuela',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.filter.collections.schools,
          value: this.filter.model.school,
          disabled: !this.filter.model.municipality,
        },
        {
          name: 'status',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Estatus del Cumplimiento',
          placeholder: 'Seleccionar',
          class: 'col-md-3',
          options: this.filter.collections.statuses,
          value: this.filter.model.status,
          disabled:
            this.filter.model.status &&
            this.filter.collections.statuses.length === 1,
        },
      ];
    },
  },
  async mounted() {
    await this.initFilters();
  },
  methods: {
    async process() {
      const valid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!valid) return;
      const payload = {
        academicYearId: this.filter.model.academicYear.id,
        centerId: this.filter.model.center.id,
        municipalityId: this.filter.model.municipality?.id,
        schoolId: this.filter.model.school?.id,
        hasHipaa: this.filter.model.status?.id,
      };
      const { data } = await ReportServices.getTherapyRoomsHipaaReport(payload);
      DocumentServices.Download(data);
    },
    async initFilters() {
      await this.getAcademicYears();
    },
    async getAcademicYears() {
      const { data } = await AcademicYearServices.getAcademicYearsFromMinType();
      this.filter.collections.academicYears = data;
      if (data.length === 1) {
        this.filter.model.academicYear = data[0];
        await this.onChangeAcademicYear();
      }
    },
    async getCenters() {
      this.filter.collections.centers = [];
      this.filter.model.center = null;
      const { data } = await LocationServices.getCenters({
        academicYearId: this.filter.model.academicYear.id,
      });
      this.filter.collections.centers = data;
      if (data.length === 1) {
        this.filter.model.center = data[0];
        await this.onChangeCenter();
      }
    },
    async getMunicipalities() {
      this.filter.collections.municipalities = [];
      this.filter.model.municipality = null;
      const { data } = await LocationServices.getMunicipalities({
        academicYearId: this.filter.model.academicYear.id,
        centerId: this.filter.model.center.id,
      });
      this.filter.collections.municipalities = data;
      if (data.length === 1) {
        this.filter.model.municipality = data[0];
        await this.onChangeMunicipality();
      }
    },
    async getSchools() {
      this.filter.collections.schools = [];
      this.filter.model.school = null;
      const { data } = await LocationServices.getSchools({
        academicYearId: this.filter.model.academicYear.id,
        centerId: this.filter.model.center.id,
        municipalityId: this.filter.model.municipality.id,
      });
      this.filter.collections.schools = data;
      if (data.length === 1) {
        this.filter.model.school = data[0];
      }
    },
    async onChangeAcademicYear() {
      if (this.filter.model.academicYear) await this.getCenters();
    },
    async onChangeCenter() {
      if (this.filter.model.center) await this.getMunicipalities();
    },
    async onChangeMunicipality() {
      if (this.filter.model.municipality) await this.getSchools();
    },
  },
};
</script>

<style scope>
.btn-process-custom {
  position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>
